import axios from 'axios'
import user from '../data/user'
import router from '../router'
import stubs from '../stubs'

const refreshDelay = 720000
const instance = axios.create()

const AUTH_SERVICE_URL = process.env.VUE_APP_AUTH_SERVICE_URL
const AUTHENTICATION_URL = process.env.VUE_APP_AUTHENTICATION_URL
const FILESPOT_SERVICE_URL = process.env.VUE_APP_FILESPOT_SERVICE_URL
const API_SERVICE_URL = process.env.VUE_APP_API_SERVICE_URL
const RECORDER_SERVICE_URL = process.env.VUE_APP_RECORDER_SERVICE_URL
const CDN_STATS_URL = process.env.VUE_APP_CDN_STATS_URL
const IAM_SERVICE_URL = process.env.VUE_APP_IAM_SERVICE_URL
const DASHBOARD_SERVICE_URL = process.env.VUE_APP_DASHBOARD_SERVICE
const CDNVIDEO_URL = process.env.VUE_APP_CDNVIDEO_API_SERVICE
const STREAMER_SERVICE_URL = process.env.VUE_APP_STREAMER_SERVICE_URL
const PLAYER_SERVICE_URL = process.env.VUE_APP_PLAYER_SERVICE
const TRANSCODER_SERVICE_URL = process.env.VUE_APP_TRANSCODER_SERVICE_URL
const DNS_SERVICE_URL = process.env.VUE_APP_DNS_SERVICE_URL

const CONTAINER_ID = '{container_id}'
const USER_ID = '{userId}'
const SUBUSER_ID = '{subuserId}'

const config = {
  login: {
    url: `${AUTHENTICATION_URL}/token`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  refresh: {
    url: `${IAM_SERVICE_URL}/token/refresh`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    }
  },
  registration: {
    url: `${AUTH_SERVICE_URL}/autoreg`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  restore: {
    url: `${AUTH_SERVICE_URL}/pwrecovery`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  pwrecovery: {
    url: `${AUTH_SERVICE_URL}/pwrecovery`,
    method: 'patch',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  confirmRegister: {
    url: `${AUTH_SERVICE_URL}/autoreg/confirm`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  recaptcha: {
    url: `${AUTH_SERVICE_URL}/recaptcha`
  },

  // Users
  getUsers: {
    url: `${AUTH_SERVICE_URL}/api/user`
  },
  getUserData: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}`
  },
  getUserProfile: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/profiles`
  },
  changeUserProfile: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/profiles`,
    method: 'patch'
  },
  changeUserPassword: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/password`,
    method: 'patch'
  },

  // Subusers
  createSubuser: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers`,
    method: 'post'
  },
  getSubusers: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers`
  },
  getSubuserData: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers/${SUBUSER_ID}`
  },
  changeSubuser: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers/${SUBUSER_ID}`,
    method: 'patch'
  },
  deleteSubuser: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers/${SUBUSER_ID}`,
    method: 'delete'
  },
  createSubuserProfile: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers/${SUBUSER_ID}/profiles`,
    method: 'post'
  },
  getSubuserProfile: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers/${SUBUSER_ID}/profiles`,
    method: 'get'
  },
  changeSubuserProfile: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers/${SUBUSER_ID}/profiles`,
    method: 'patch'
  },
  changeSubuserPassword: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/subusers/${SUBUSER_ID}/password`,
    method: 'patch'
  },
  generateS3Credentials: {
    url: `${IAM_SERVICE_URL}/1/users/${USER_ID}{paramSubuser}/s3-credentials`,
    method: 'post'
  },

  getObjects: {
    url: `${FILESPOT_SERVICE_URL}/2/fs/container/${CONTAINER_ID}/object{path}?strong`
  },
  getObject: {
    url: `${FILESPOT_SERVICE_URL}/2/fs/container/${CONTAINER_ID}/object_id/{id}`
  },
  removeObject: {
    url: `${FILESPOT_SERVICE_URL}/2/fs/container/${CONTAINER_ID}/object{path}`,
    method: 'delete'
  },
  uploadObject: {
    url: `${FILESPOT_SERVICE_URL}/2/fs/container/${CONTAINER_ID}/object{path}`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  downloadObject: {
    url: `${API_SERVICE_URL}/1/download`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  getDownloadObjects: {
    url: `${API_SERVICE_URL}/1/download_tasks`
  },
  updateObject: {
    url: `${FILESPOT_SERVICE_URL}/2/fs/container/${CONTAINER_ID}/object{path}`,
    method: 'put'
  },
  createFolder: {
    url: `${FILESPOT_SERVICE_URL}/2/fs/container/${CONTAINER_ID}/object{path}?dir`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  findObjects: {
    url: `${FILESPOT_SERVICE_URL}/2/fs/container/${CONTAINER_ID}/search`
  },
  getContainer: {
    url: `${FILESPOT_SERVICE_URL}/2/fs/container`
  },
  getTempLinks: {
    url: `${API_SERVICE_URL}/1/temp?object_id={fileId}`
  },
  createTempLink: {
    url: `${API_SERVICE_URL}/1/temp`,
    method: 'post'
  },
  updateTempLink: {
    url: `${API_SERVICE_URL}/1/temp/{id}`,
    method: 'post'
  },
  removeTempLink: {
    url: `${API_SERVICE_URL}/1/temp/{id}`,
    method: 'delete'
  },
  getPlayers: {
    url: `${API_SERVICE_URL}/1/players`
  },
  getTranscoderPreset: {
    url: `${API_SERVICE_URL}/1/transcoder/presets/{id}`
  },
  getTranscoderPresets: {
    url: `${API_SERVICE_URL}/1/transcoder/presets`
  },
  getTranscoderTasks: {
    url: `${API_SERVICE_URL}/1/transcoder_tasks?{query}`
  },
  transcode: {
    url: `${API_SERVICE_URL}/1/transcoder/{id}`,
    method: 'post'
  },
  transcodeHls: {
    url: `${API_SERVICE_URL}/1/transcoder/hls/{id}`,
    method: 'post'
  },
  getTranscoderStats: {
    url: `${API_SERVICE_URL}/1/transcoder/stat`
  },
  createStream: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}`,
    method: 'post'
  },
  getStreams: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}`
  },
  getStream: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{id}`
  },
  removeStream: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{id}`,
    method: 'delete'
  },
  updateStream: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{id}`,
    method: 'put'
  },
  startInstantRecord: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{id}/start`,
    method: 'post'
  },
  getRecord: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{streamId}/record/{recordId}`
  },
  createRecord: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{streamId}/record`,
    method: 'post'
  },
  updateRecord: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{streamId}/record/{recordId}`,
    method: 'put'
  },
  getRecords: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{streamId}/record`
  },
  removeRecord: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{streamId}/record/{recordId}`,
    method: 'delete'
  },
  stopRecord: {
    url: `${RECORDER_SERVICE_URL}/${CONTAINER_ID}/{streamId}/record/{recordId}/stop`,
    method: 'post'
  },
  deleteTask: {
    url: `${API_SERVICE_URL}/1/{category}/{id}`,
    method: 'delete'
  },
  getTasks: {
    url: `${API_SERVICE_URL}/1/{category}`
  },
  getTask: {
    url: `${API_SERVICE_URL}/1/{category}/{id}`
  },

  sendFeedback: {
    url: `${AUTH_SERVICE_URL}/api/feedback`,
    method: 'post'
  },
  postCutVideoTask: {
    url: `${API_SERVICE_URL}/1/tasks/cmd/transcode`
  },

  // DNS
  getZones: {
    url: `${DNS_SERVICE_URL}/zones`
  },
  getZone: {
    url: `${DNS_SERVICE_URL}/zones/{name}`
  },
  createZone: {
    url: `${DNS_SERVICE_URL}/zones`,
    method: 'post'
  },
  updateZone: {
    url: `${DNS_SERVICE_URL}/zones/{name}`,
    method: 'patch'
  },
  removeZone: {
    url: `${DNS_SERVICE_URL}/zones/{name}`,
    method: 'delete'
  },
  enableZone: {
    url: `${DNS_SERVICE_URL}/zones/{name}/enable`,
    method: 'post'
  },
  disableZone: {
    url: `${DNS_SERVICE_URL}/zones/{name}/disable`,
    method: 'post'
  },

  getZoneRRSets: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/rrsets`
  },
  createZoneRRSet: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/rrsets`,
    method: 'post'
  },
  getZoneRRSet: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/rrsets/{rRSetName}`
  },
  removeZoneRRSet: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/rrsets/{rRSetName}`,
    method: 'delete'
  },
  getZoneRRSetByType: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/rrsets/{rRSetName}/{rRSetType}`
  },
  updateZoneRRSetByType: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/rrsets/{rRSetName}/{rRSetType}`,
    method: 'put'
  },
  removeZoneRRSetByType: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/rrsets/{rRSetName}/{rRSetType}`,
    method: 'delete'
  },

  getZoneRecords: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/records`
  },
  getZoneRecord: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/records/{recordId}`
  },
  createZoneRecord: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/records`,
    method: 'post'
  },
  updateZoneRecord: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/records/{recordId}`,
    method: 'put'
  },
  removeZoneRecord: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/records/{recordId}`,
    method: 'delete'
  },
  enableZoneRecord: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/records/{recordId}/enable`,
    method: 'post'
  },
  disableZoneRecord: {
    url: `${DNS_SERVICE_URL}/zones/{zoneName}/records/{recordId}/disable`,
    method: 'post'
  },

  // // Player branding
  // brandCreate: {
  //   url: 'https://api.platformcraft.ru/brands',
  //   method: 'post'
  // },
  // brandsGet: {
  //   url: 'https://my.platformcraft.ru/brands',
  //   method: 'get'
  // },
  // brandGet: {
  //   url: 'https://api.platformcraft.ru/brands/{id}',
  //   method: 'get'
  // },
  // brandChange: {
  //   url: 'https://api.platformcraft.ru/brand/{id}',
  //   method: 'put'
  // },
  // brandDelete: {
  //   url: 'https://api.platformcraft.ru/brand/{id}',
  //   method: 'delete'
  // },

  // CDN Stats
  getCdnToken: {
    url: `${CDN_STATS_URL}/token`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    }
  },
  getCdnStats: {
    url: `${CDN_STATS_URL}/`
  },
  getCdnAccounts: {
    url: `${CDN_STATS_URL}/accounts`
  },
  getCdnResources: {
    url: `${CDN_STATS_URL}/resources`
  },
  getCdnStatsByTime: {
    url: `${CDN_STATS_URL}/times`
  },
  getCdnStatsByBrowsers: {
    url: `${CDN_STATS_URL}/browsers`
  },
  getCdnStatsByCodes: {
    url: `${CDN_STATS_URL}/times/codes`
  },
  getCdnStatsByReferrers: {
    url: `${CDN_STATS_URL}/referrers`
  },
  getCdnStatsByPlatforms: {
    url: `${CDN_STATS_URL}/platforms`
  },
  getCdnStatsByRegions: {
    url: `${CDN_STATS_URL}/regions`
  },
  getCdnStatsByCountries: {
    url: `${CDN_STATS_URL}/countries`
  },
  getCdnStatsByHosts: {
    url: `${CDN_STATS_URL}/hosts`
  },

  // Groups
  getGroups: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/groups`
  },
  createGroup: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/groups`,
    method: 'post'
  },
  getGroup: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/groups/{groupId}`
  },
  changeGroup: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/groups/{groupId}`,
    method: 'patch'
  },
  deleteGroup: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/groups/{id}`,
    method: 'delete'
  },

  // Roles
  createRole: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/roles`,
    method: 'post'
  },
  getRoles: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/roles`
  },
  getRole: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/roles/{id}`
  },
  changeRole: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/roles/{id}`,
    method: 'patch'
  },
  deleteRole: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/roles/{id}`,
    method: 'delete'
  },

  // Policies
  createPolicy: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/policies`,
    method: 'post'
  },
  getPoliciesInsideAccount: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/policies`
  },
  getSubuserPolicies: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/policies?principal=subuser:${SUBUSER_ID}`
  },
  getPolicy: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/policies/{id}`
  },
  changePolicy: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/policies/{id}`,
    method: 'patch'
  },
  deletePolicy: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/policies/{id}`,
    method: 'delete'
  },
  getAccountServices: {
    url: `${IAM_SERVICE_URL}/services`
  },
  getAccountPolicy: {
    url: `${IAM_SERVICE_URL}/users/${USER_ID}/policies/account`
  },

  // dashboard
  getUserAccess: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}/access`
  },
  getSubuserAccess: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}/subusers/${SUBUSER_ID}/access`
  },
  getUserSettings: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}/settings`
  },
  getSubuserSettings: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}/subusers/${SUBUSER_ID}/settings`
  },
  setDefaultPrivateFiles: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}{subuserParam}/settings/default-private-files/{value}`, // value = enable | disable
    method: 'post'
  },
  setDefaultAutotranscoding: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}{subuserParam}/settings/autotranscoding/{value}`, // value = enable | disable
    method: 'post'
  },
  setHomeDir: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}/subusers/${SUBUSER_ID}/settings/filespot/containers/${CONTAINER_ID}/home_dir`,
    method: 'post'
  },
  changeAutotranscodingSettings: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}{subuserParam}/settings/autotranscoding`,
    method: 'post'
  },
  enableMultifactor: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}/settings/multifactor/enable`,
    method: 'post'
  },
  disableMultifactor: {
    url: `${DASHBOARD_SERVICE_URL}/1/account/users/${USER_ID}/settings/multifactor/disable`,
    method: 'post'
  },
  getS3Stats: {
    url: `${DASHBOARD_SERVICE_URL}/1/stats/users/${USER_ID}/services/s3/space`
  },
  getS3bucketStat: {
    url: `${DASHBOARD_SERVICE_URL}/1/stats/users/${USER_ID}/services/s3/bucket/{name}`,
    method: 'get'
  },

  // CDNVideo
  addToCDNCache: {
    url: `${CDNVIDEO_URL}/1/users/${CONTAINER_ID}/cache`,
    method: 'put'
  },
  clearCDNCache: {
    url: `${CDNVIDEO_URL}/1/users/${CONTAINER_ID}/cache`,
    method: 'delete'
  },

  // Channels
  createChannel: {
    url: `${STREAMER_SERVICE_URL}/3/channels`,
    method: 'post'
  },
  getChannels: {
    url: `${STREAMER_SERVICE_URL}/3/channels`
  },
  getChannel: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}`,
    method: 'get'
  },
  updateChannel: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}`,
    method: 'patch'
  },
  removeChannel: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}`,
    method: 'delete'
  },
  startChannel: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/start`,
    method: 'post'
  },
  stopChannel: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/stop`,
    method: 'post'
  },
  copyChannel: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/copy`,
    method: 'post'
  },

  // Channel MediaBlocks
  createChannelMediaBlock: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks`,
    method: 'post'
  },
  getChannelMediaBlocks: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks`,
    method: 'get'
  },
  getChannelBlock: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks/{id}`,
    method: 'get'
  },
  updateChannelMediaBlock: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks/{id}`,
    method: 'patch'
  },
  updateChannelBlocks: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks`,
    method: 'patch'
  },
  deleteChannelMediaBlock: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks/{id}`,
    method: 'delete'
  },
  scheduleChannelMediaBlock: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks/{id}/schedule`,
    method: 'post'
  },
  startChannelMediaBlock: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks/{id}/start`,
    method: 'post'
  },
  stopChannelMediaBlock: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks/{id}/stop`,
    method: 'post'
  },
  copyChannelMediaBlock: {
    url: `${STREAMER_SERVICE_URL}/3/channels/{channelId}/blocks/{id}/copy`,
    method: 'post'
  },

  // Player branding
  brandCreate: {
    url: `${PLAYER_SERVICE_URL}/containers/${CONTAINER_ID}/templates`,
    method: 'post'
  },
  getBrands: {
    url: `${PLAYER_SERVICE_URL}/containers/${CONTAINER_ID}/templates`
  },
  getBrand: {
    url: `${PLAYER_SERVICE_URL}/containers/${CONTAINER_ID}/templates/{id}`
  },
  updateBrand: {
    url: `${PLAYER_SERVICE_URL}/containers/${CONTAINER_ID}/templates/{id}`,
    method: 'patch'
  },
  deleteBrand: {
    url: `${PLAYER_SERVICE_URL}/containers/${CONTAINER_ID}/templates/{id}`,
    method: 'delete'
  },
  // Client info
  getInfo: {
    url: `${DASHBOARD_SERVICE_URL}/1/client-info`
  }
}

const handlers = {
  success: [],
  error: []
}

let isRefreshing = false
let refreshSubscribers = []

const subscribeToRefresh = (callback) => {
  refreshSubscribers.push(callback)
}
const onRefreshed = (newToken) => {
  refreshSubscribers.forEach((callback) => callback(newToken))
  refreshSubscribers = []
}

const api = {
  addHandler (handler, type) {
    handlers[type].push(handler)
    return this
  },
  onSuccess (response) {
    let breakChain = false

    handlers.success.forEach(handler => {
      if (handler(response) === false) {
        breakChain = true
      }
    })

    return breakChain ? (new Promise(() => {})) : response
  },
  token: null,
  async refreshOnlyToken () {
    const token = localStorage.getItem('refresh_token')
    const id = localStorage.getItem('user_id')

    if (!id || !token) {
      return new Promise((resolve, reject) => {
        reject(new Error('Refresh info is not found'))
      })
    }

    try {
      const { data } = await api.refresh({
        user_id: id,
        refresh_token: token
      })

      this.token = data.access_token
      localStorage.setItem('refresh_token', data.refresh_token)
      localStorage.setItem('user_id', data.subuser_id || data.user_id)
      localStorage.setItem('expires_at', data.expires_at)

      return data.access_token
    } catch (err) {
      console.error('refreshOnlyToken error:', err)
    }
  },
  refreshToken () {
    const token = localStorage.getItem('refresh_token')
    const id = localStorage.getItem('user_id')

    if (!token || !id) {
      return new Promise((resolve, reject) => {
        reject(new Error('Refresh info is not found'))
      })
    }

    return this.refresh({
      user_id: id,
      refresh_token: token
    }).then(res => {
      setInterval(async () => {
        await this.refreshOnlyToken()
      }, refreshDelay)
      return this.setToken(res.data)
    })
  },
  async setToken (data) {
    this.token = data.access_token
    user.id = data.subuser_id || data.user_id

    localStorage.setItem('refresh_token', data.refresh_token)
    localStorage.setItem('user_id', data.subuser_id || data.user_id)
    localStorage.setItem('expires_at', data.expires_at)

    const userId = data.user_id
    const subuserId = user.id
    const isOwner = userId === subuserId

    return this.loadUserData(userId, subuserId, isOwner)
  },

  async loadUserData (userId, subuserId, isOwner) {
    try {
      const method = isOwner ? this.getUserData : this.getSubuserData
      const { data } = await method({ userId, subuserId })

      if (!data.id && data.user_id !== undefined) {
        data.id = data.user_id
      }

      user.setUserData(data)

      const accessMethod = isOwner ? this.getUserAccess : this.getSubuserAccess
      const settingsMethod = isOwner ? this.getUserSettings : this.getSubuserSettings
      const profileMethod = isOwner ? this.getUserProfile : this.getSubuserProfile

      this.getInfo(null, { timeout: 5000 })
        .then(res => {
          user.ip = res.data.ip
        })
        .catch(error => {
          console.warn('Unable to retrieve IP:', error)
        })

      const [accessResponse, settingsResponse, profileResponse] = await Promise.all([
        accessMethod({ userId, subuserId }),
        settingsMethod({ subuserId }),
        profileMethod({ userId, subuserId }).catch(() => {
          console.warn('Unable to retrieve user profile, please contact your admin.')
          return null
        })
      ])

      user.setUserAccess(accessResponse.data)
      user.setUserSettings(settingsResponse.data)
      if (profileResponse?.data) {
        user.setUserProfile(profileResponse.data)
      }
    } catch (err) {
      console.error('Error retrieving user data:', err)
      throw err
    }
  },

  async loadProfile (userId, subuserId) {
    const method = userId === subuserId ? this.getUserProfile : this.getSubuserProfile
    await method({ userId, subuserId }).then(({ data }) => {
      user.setUserProfile(data)
    })
  },
  logout () {
    this.token = null
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user_id')
    localStorage.removeItem('CDN_TOKEN')
    localStorage.removeItem('CDN_TOKEN_LIVE_TIME')
    localStorage.removeItem('session_key')
    user.id = null
    user.user_id = null
    router.push({
      name: 'login'
    })
  }
}

Object.keys(config).forEach(function (method) {
  const endpoint = config[method]

  api[method] = function (data, params = {}) {
    const config = Object.assign({}, params, {
      url: endpoint.url,
      method: endpoint.method || 'get',
      headers: endpoint.headers || {}
    })

    if (user.user_id && config.url.match(USER_ID)) {
      config.url = config.url.replace(USER_ID, user.user_id)
    }

    if (config.url.match(CONTAINER_ID)) {
      config.url = config.url.replace(CONTAINER_ID, user.user_id)
    }

    if (data instanceof FormData) {
      for (const item of data.entries()) {
        const [key, value] = item
        config.url = config.url.replace('{' + key + '}', () => {
          data.delete(key)
          return value
        })
      }
    } else if (data instanceof Object) {
      Object.keys(data).forEach((item) => {
        config.url = config.url.replace('{' + item + '}', () => {
          const value = data[item]
          delete data[item]
          return value
        })
      })
    }

    if (config.method === 'get') {
      config.params = data
    } else {
      if (data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        const query = new URLSearchParams()

        Object.keys(data).forEach(function (key) {
          query.append(key, data[key])
        })
        config.data = query
      } else {
        config.data = data
      }
    }

    if (endpoint.stub) {
      return new Promise(resolve => {
        const response = stubs[endpoint.url]

        if (typeof response === 'function') {
          resolve({ data: response() })
        } else {
          throw new Error(endpoint.url)
        }
      })
    }

    return request(config)
  }
})

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    const isUpload = originalRequest.method === 'post' && originalRequest?.headers['Content-Type'] === 'multipart/form-data' && error?.code === 'ERR_NETWORK'

    if (isUpload) {
      if (isRefreshing) {
        return Promise.reject(error)
      }

      isRefreshing = true
      try {
        await api.refreshOnlyToken()
        return Promise.reject(error)
      } catch (refreshError) {
        api.logout()
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }

    if (
      error.response?.status === 403 &&
      error.response?.data?.code === 403 &&
      error.response?.data?.msg === 'token expired' &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise((resolve) => {
          subscribeToRefresh((newToken) => {
            originalRequest.headers.Authorization = `Bearer ${newToken}`
            resolve(instance(originalRequest))
          })
        })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const newToken = await api.refreshOnlyToken()

        isRefreshing = false
        onRefreshed(newToken)
        originalRequest.headers.Authorization = `Bearer ${newToken}`
        return instance(originalRequest)
      } catch (refreshError) {
        isRefreshing = false
        refreshSubscribers = []

        api.logout()
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

function request (params) {
  if (api.token) {
    params.headers = params.headers || {}
    params.headers.Authorization = `Bearer ${api.token}`
  }
  return instance.request(params).then(api.onSuccess)
}

export default api
